import { render } from "./PhysicalMetrics.vue?vue&type=template&id=5a883e1c"
import script from "./PhysicalMetrics.vue?vue&type=script&lang=js"
export * from "./PhysicalMetrics.vue?vue&type=script&lang=js"

import "./PhysicalMetrics.vue?vue&type=style&index=0&id=5a883e1c&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__